var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighway(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91064 14.5308H7.50293V12.6538H24.3955V14.5308H22.9878",
    stroke: "var(--iconPrimary)",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9492 22.9771V14.5308V14.0615",
    stroke: "var(--iconPrimary)",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9492 11.2466V8.43115",
    stroke: "var(--iconPrimary)",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4631_56265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 18,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9263 22.9771L18.2954 7.02295H15.9492H13.603L7.97217 22.9771H23.9263Z",
    stroke: "var(--iconPrimary)",
    strokeWidth: 1.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4631_56265)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84961 11.2465V14.0616H22.0495V11.2465H9.84961ZM24.8649 14.0616V11.2465H24.8652V5.61565H24.8649V5.61523H22.0495V5.61565H9.84961V5.61523H7.03418V5.61565V11.2465V14.0616V15.9385V23.4464H24.8652V14.0616H24.8649Z",
    fill: "var(--iconPrimary)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighway);
export default __webpack_public_path__ + "static/media/highway.e4ee2f8b37e96a98d07e4f0103ac0805.svg";
export { ForwardRef as ReactComponent };